// extracted by mini-css-extract-plugin
export default {"delete_topic__wrapper":"styles_delete_topic__wrapper__YpeAp","buttons__wrapper":"styles_buttons__wrapper__KeGHy"};